// GoogleAdsOutlineWhite.jsx
export function GoogleAdsLogoOutline({ size = 20, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
    >
      {/* "Raio" esquerdo */}
      <path d="M26 1 L10 44" />
      {/* "Raio" direito */}
      <path d="M23 1 L7 44" />
      {/* Círculo */}
      <circle cx="39.5" cy="39" r="7" fill="currentColor" stroke="none" strokeWidth="5.4"/>
    </svg>
  );
}